export default "__VITE_ASSET__T0SZyq24__"